import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../../contexts/DialogContext';
import { useBackfillSBOMSummaryData } from '../../../hooks/api/backfills/useBackfillSBOMSummaryData';
import Button from '../../generic/Button';
import Card from '../../generic/Card/Card';
import Text from '../../generic/Text';

/**
 * Shows a button to trigger backfill SBOM summary data.
 */
export const BackfillSBOMSummaryData: VoidFunctionComponent = () => {
  const { mutate: backfillSBOMData, isPending } = useBackfillSBOMSummaryData();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Backfill SBOM Summary Data',
      body: (
        <div>
          Are you sure you want to backfill SBOM summary data?
        </div>
      ),
      onConfirm: async () => {
        backfillSBOMData();
      },
    });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Backfill SBOM Summary Data</Card.Header>
      <Card.Content>
        <Text.Paragraph>
          This will queue a background job that backfills data required for SBOM analysis.
        </Text.Paragraph>
        <Button onClick={onButtonClick} isDisabled={isPending}>
          Backfill
        </Button>
      </Card.Content>
    </Card>
  );
};

export default BackfillSBOMSummaryData;
